// extracted by mini-css-extract-plugin
export default {"legend":"MXKgABCQgF9fy6vncuXF"};